// Features
export const SURVEY = 'Survey';
export const POLL = 'Poll';
export const HANDOUTS = 'Handouts';

// Survey Attributes
export const TITLE = 'Title';
export const QUESTION = 'Question';
export const SETTINGS = 'Settings';
